import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import SEO from "../components/SEO";

export default function NotFound() {
  return (
    <main data-testid="not-found-page" className="bg-[#FDFBF7] min-h-screen flex items-center">
      <SEO
        title="Not found"
        description="That page seems to have wandered off."
        path="/404"
      />
      <div className="max-w-3xl mx-auto px-6 lg:px-10 py-32 text-center">
        <p className="kicker text-stone-500">404</p>
        <h1 className="font-serif text-5xl sm:text-6xl font-light tracking-tight mt-6">
          A wrong turn,
          <br />
          <em className="italic">but not a dead end.</em>
        </h1>
        <p className="mt-8 text-stone-600 max-w-xl mx-auto">
          The page you're looking for isn't here. Most travel detours lead somewhere
          interesting — try one of these.
        </p>
        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/"
            data-testid="not-found-home"
            className="inline-flex items-center gap-2 px-7 py-3.5 border border-stone-900 text-stone-900 text-[12px] tracking-[0.25em] uppercase font-semibold hover:bg-stone-900 hover:text-[#FDFBF7] transition-colors"
          >
            <ArrowLeft size={14} /> Back home
          </Link>
          <Link
            to="/destinations"
            data-testid="not-found-destinations"
            className="text-[12px] tracking-[0.25em] uppercase font-semibold text-stone-600 hover:text-[#9c4122] transition-colors"
          >
            Browse all destinations
          </Link>
        </div>
      </div>
    </main>
  );
}
